import http from '../../../Http';
import { useContext, useState, useRef, useEffect } from 'react';
import utils from '../../../utils';
import { Modal, Button, Input, Form, Select, Table, Row, Col } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

function AddInverterBurning(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const { showAddBurning, onClose } = props;

    //Firmware
    const [pageNoFirmware, setPageNoFirmware] = useState(0);
    const [pageSizeFirmware, setPageSizeFirmware] = useState(25);
    const [paramsFirmware, setParamsFirmware] = useState({
        InverterModel: '',
        FileName: '',
        Version: '',
    });
    const [inverterModel, setInverterModel] = useState(null);
    const [loadingFirmware, setLoadingFirmware] = useState(false);
    const [rowsFirmware, setRowsFirmware] = useState([]);
    const [rowTotalFirmware, setRowTotalFirmware] = useState(0);
    const [tableBodyHeightFirmware, setTableBodyHeightFirmware] = useState(240);
    const [selectedKeysFirmware, setSelectedKeysFirmware] = useState([]);
    const [selectedRowsFirmware, setSelectedRowsFirmware] = useState([]);
    const [expandFirmware, setExpandFirmware] = useState(false);
    const [formSearcherFirmware] = Form.useForm();
    const [inverterModelSelectOptions, setInverterModelSelectOptions] = useState([]);
    const refTableContainerFirmware = useRef();
    const refTimerInverterModelSearcher = useRef(null);
    const refInverterModelSearchValue = useRef(null);

    //Inverter
    const [pageNoInverter, setPageNoInverter] = useState(0);
    const [pageSizeInverter, setPageSizeInverter] = useState(25);
    const [paramsInverter, setParamsInverter] = useState({
        SerialNumber: '',
        Model: '',
        DistributorName: '',
    });
    const [loadingInverter, setLoadingInverter] = useState(false);
    const [rowsInverter, setRowsInverter] = useState([]);
    const [rowTotalInverter, setRowTotalInverter] = useState(0);
    const [tableBodyHeightInverter, setTableBodyHeightInverter] = useState(240);
    const [selectedKeysInverter, setSelectedKeysInverter] = useState([]);
    const [selectedRowsInverter, setSelectedRowsInverter] = useState([]);
    const [formSearcherInverter] = Form.useForm();
    const refTableContainerInverter = useRef();

    //get Firmware list
    useEffect(() => {
        let active = true;
        (async () => {
            setLoadingFirmware(true);
            let resp = await http.post("integrated-inverter/firmware/list2", {
                PageNo: pageNoFirmware,
                PageSize: pageSizeFirmware,
                ...paramsFirmware
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter record error") });
                setRowTotalFirmware(0)
                setRowsFirmware([]);
                return;
            }

            setRowTotalFirmware(resp.data.RowTotal);
            setRowsFirmware(resp.data.Rows);
            setLoadingFirmware(false);
        })();

        return () => {
            active = false;
        };

    }, [pageNoFirmware, pageSizeFirmware, paramsFirmware, t]);

    //get inverter list
    useEffect(() => {
        if (inverterModel == null) {
            return;
        }

        let active = true;

        (async () => {
            setLoadingInverter(true);
            let resp = await http.post("integrated-inverter/list", {
                PageNo: pageNoInverter,
                PageSize: pageSizeInverter,
                ...paramsInverter,
                Model: inverterModel
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter list error") });
                setRowTotalInverter(0)
                setRowsInverter([]);
                return;
            }

            setRowTotalInverter(resp.data.length);
            setRowsInverter(resp.data);
            setLoadingInverter(false);
        })();

        return () => {
            active = false;
        };

    }, [pageNoInverter, pageSizeInverter, paramsInverter, inverterModel, t]);

    const handleSearchInverterModel = (v) => {
        if (refTimerInverterModelSearcher.current != null) {
            clearTimeout(refTimerInverterModelSearcher.current);
        }
        refInverterModelSearchValue.current = v;

        refTimerInverterModelSearcher.current = setTimeout(async () => {
            const resp = await http.post("integrated-inverter/model/list", {
                Value: v
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (refInverterModelSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter model error") });
                    return;
                }

                const ls = resp.data.map(({ ID, Name }) => {
                    return (
                        <Select.Option key={ID} value={Name}>{Name}</Select.Option>
                    );
                });
                setInverterModelSelectOptions(ls);
            } catch (e) {
                setTip({ open: true, severity: "error", msg: t("load inverter model error") });
            }
        }, 300);
    }

    //search firmware
    const handleSearchFirmware = () => {
        setPageNoFirmware(0);
        const ps = formSearcherFirmware.getFieldsValue();
        ps.InverterModel = ps.InverterModel || '';
        ps.FileName = ps.FileName || '';
        ps.Version = ps.Version || '';
        setParamsFirmware(ps)
    }

    //search inverter
    const handleSearchInverter = () => {
        setPageNoInverter(0);
        const ps = formSearcherInverter.getFieldsValue();
        ps.SerialNumber = ps.SerialNumber || '';
        ps.DistributorName = ps.DistributorName || '';
        ps.UserID = ps.UserID || '';
        setParamsInverter(ps)
    }

    const handleSelectFirmware = (selectedRowKeys, selectedRows) => {
        setSelectedKeysFirmware([...selectedRowKeys]);
        setSelectedRowsFirmware(selectedRows);
        setInverterModel(selectedRows[0].InverterModel);
    }

    const handleSelectInverter = (selectedRowKeys, selectedRows) => {
        setSelectedKeysInverter([...selectedRowKeys]);
        setSelectedRowsInverter(selectedRows);
    }

    useEffect(() => {
        const el = refTableContainerFirmware.current;

        if (!el || el.objResizer) {
            return;
        }

        let obj = document.createElement('object');
        el.objResizer = obj;
        obj.setAttribute('style',
            'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;');
        obj.onload = function () {
            setTableBodyHeightFirmware(calcTableBodyHeight(refTableContainerFirmware));

            this.contentDocument.defaultView.addEventListener('resize', (evt) => {
                setTableBodyHeightFirmware(calcTableBodyHeight(refTableContainerFirmware));
            });
        };
        obj.type = 'text/html';
        el.appendChild(obj);
        obj.data = 'about:blank';

        return () => {
            if (!el) {
                return
            }

            //
        }
    }, [refTableContainerFirmware.current]);

    useEffect(() => {
        const el = refTableContainerInverter.current;

        if (!el || el.objResizer) {
            return;
        }

        let obj = document.createElement('object');
        el.objResizer = obj;
        obj.setAttribute('style',
            'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;');
        obj.onload = function () {
            setTableBodyHeightInverter(calcTableBodyHeight(refTableContainerInverter));

            this.contentDocument.defaultView.addEventListener('resize', (evt) => {
                setTableBodyHeightInverter(calcTableBodyHeight(refTableContainerInverter));
            });
        };
        obj.type = 'text/html';
        el.appendChild(obj);
        obj.data = 'about:blank';

        return () => {
            if (!el) {
                return
            }

            //
        }
    }, [refTableContainerInverter.current]);

    const calcTableBodyHeight = (ref) => {
        if (!ref.current) {
            return 200;
        }

        const hd = ref.current.parentElement.getElementsByClassName("ant-table-thead")[0];

        const h = ref.current.getBoundingClientRect().bottom - hd.getBoundingClientRect().bottom;

        return h >= 54 ? h - 54 : h / 2;
    }

    const handleCancle = () => {
        onClose();
    }

    const handleSubmit = async () => {
        if (selectedKeysFirmware.length < 1) {
            setTip({ open: true, severity: 'error', msg: t("The Firmare must be selected one") });
            return;
        }
        if (selectedKeysInverter.length < 1) {
            setTip({ open: true, severity: 'error', msg: t("The Inverter SN must be selected some") });
            return;
        }

        const ps = {
            FirmwareID: selectedKeysFirmware[0],
            Inverters: selectedRowsInverter.map(d => `${d.ID},${d.SN}`).join("|"),
        };

        const resp = await http.post("integrated-inverter/burning/add", ps).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            console.log("[InverterBurningAdd]", e);
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("add error") });
                return
            }

            setTip({ open: true, severity: 'success', msg: t('add success') });

            const rds = {};
            resp.data.IDs.forEach((v) => {
                rds[v.InverterID] = v
            });

            const rows = [];
            const f = selectedRowsFirmware[0];
            for (let d of selectedRowsInverter) {
                const row = {
                    ID: rds[d.ID].ID,
                    InverterID: d.ID,
                    BindingID: d.ID,
                    InverterModel: d.Model,
                    FileName: f.FileName,
                    Version: f.Version,
                    DataLength: f.DataLength,
                    Progress: 0,
                    Note: f.Node,
                    CreateTime: resp.data.CreateTime,
                    SN: rds[d.ID].SN, //2024.9.28 新增
                    FirmwareID: ps.FirmwareID, //2024.9.28 新增
                };
                rows.push(row);
            }

            onClose(rows);
        } catch (e) {
            console.log("[InverterBurningAdd]", e);

            setTip({ open: true, severity: "error", msg: t("add error") });
        }
    }

    const handleClose = () => {
        onClose();
    }


    return (
        <Modal
            forceRender={true}
            title={t('Add Inverter Burning')}
            visible={showAddBurning}
            //cancelText="Cancel"
            //okText="OK"
            mask={true}
            maskClosable={false}
            width={1000}
            onCancel={handleClose}
            onOk={handleClose}
            destroyOnClose={true}
            footer={null}
        >
            <div style={{
                display: "flex",
                flexDirection: "row",
                minHeight: "450px",
                height: "450px",
                position: "relative",
                alignItems: "stretch",
            }}>
                <div style={{
                    flex: "0 0 500",
                    width: "55%",
                    maxWidth: "55%",
                    display: "flex",
                    flexDirection: "column",
                }}>
                    <div style={{
                        flex: '0 0 auto',
                        fontWeight: "bold",
                    }}><label style={{ color: "red" }}>*</label>{t('Firmware')}:</div>
                    <div style={{
                        flex: "0 1 auto",
                    }}>
                        <Form
                            form={formSearcherFirmware}
                            preserve={false}
                            style={{
                                padding: 10,
                                background: '#fbfbfb',
                                border: '1px solid #d9d9d9',
                                borderRadius: 2
                            }}
                        >
                            <Row gutter={24}>
                                <Col span={12} key="InverterModel">
                                    <Form.Item
                                        name="InverterModel"
                                        label={t("Model")}
                                    >
                                        <Select
                                            showSearch
                                            placeholder={t("Inverter Model")}
                                            defaultActiveFirstOption={false}
                                            showArrow={false}
                                            filterOption={false}
                                            onSearch={handleSearchInverterModel}
                                            style={{width: '186px'}}
                                        >{inverterModelSelectOptions}</Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12} key="FileName">
                                    <Form.Item
                                        name="FileName"
                                        label={t("FileName")}
                                    >
                                        <Input placeholder={t("Enter File Name")} onPressEnter={handleSearchFirmware} />
                                    </Form.Item>
                                </Col>
                                <Col span={12} key="Version" style={{ display: expandFirmware ? "block" : "none" }}>
                                    <Form.Item
                                        name="Version"
                                        label={t("Version")}
                                    >
                                        <Input placeholder={t("Enter Version")} onPressEnter={handleSearchFirmware} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: 'right' }}>
                                    <Button type="primary" shape="round" onClick={handleSearchFirmware}>
                                        {t("Search")}
                                    </Button>
                                    <Button
                                        shape="round"
                                        style={{ margin: '0 8px' }}
                                        onClick={() => {
                                            formSearcherFirmware.resetFields();
                                        }}
                                    >
                                        {t("Clear")}
                                    </Button>
                                    <a
                                        style={{ fontSize: 12 }}
                                        onClick={() => {
                                            setExpandFirmware(!expandFirmware);
                                        }}
                                    >
                                        {expandFirmware ? <UpOutlined /> : <DownOutlined />} {expandFirmware ? t('Collapse') : t('Expand')}
                                    </a>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    <div style={{
                        flex: "1 1 1px",
                        position: "relative",
                    }}>
                        <div ref={refTableContainerFirmware} style={{ position: "absolute", height: '100%', width: "100%", overflow: "hidden" }}>
                            <Table
                                columns={[{
                                    title: "",
                                    width: 50,
                                    fixed: 'left',
                                    render: (v, r, idx) => {
                                        return (pageNoFirmware * pageSizeFirmware + idx + 1);
                                    }
                                }, {
                                    title: t('File Name'),
                                    dataIndex: 'FileName',
                                    width: 320,
                                }, {
                                    title: t('Inverter Model'),
                                    dataIndex: "ModelName",
                                    width: 160,
                                }, {
                                    title: t('Version'),
                                    dataIndex: 'Version',
                                    width: 60,
                                }, {
                                    title: t('Length'),
                                    dataIndex: 'DataLength',
                                    width: 70,
                                }, {
                                    title: t('Create Time'),
                                    dataIndex: 'CreateTime',
                                    width: 160,
                                }]}
                                pagination={{
                                    pageSizeOptions: [25, 50, 100],
                                    current: pageNoFirmware + 1,
                                    pageSize: pageSizeFirmware,
                                    total: rowTotalFirmware,
                                    showSizeChanger: true,
                                    showTotal: (total) => { return t('Total {{total}}', { total }) },
                                    onShowSizeChange: (current, size) => {
                                        setPageSizeFirmware(size);
                                    },
                                    onChange: (page, pageSize) => {
                                        setPageNoFirmware(page - 1);
                                    }
                                }}
                                tableLayout="fixed"
                                bordered={true}
                                size="middle"
                                loading={loadingFirmware}
                                rowKey="ID"
                                dataSource={rowsFirmware}
                                scroll={{ x: 40, y: tableBodyHeightFirmware }}
                                rowSelection={{
                                    type: "radio",
                                    selectedRowKeys: selectedKeysFirmware,
                                    onChange: handleSelectFirmware,
                                    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE]
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div style={{
                    flex: "1",
                    width: "45%",
                    height: '100%',
                    maxWidth: "45%",
                    display: "flex",
                    flexDirection: "column",
                }}>
                    <div style={{
                        flex: '0 0 auto',
                        fontWeight: "bold",
                    }}><label style={{ color: "red" }}>*</label>{t('Inverter')}:</div>
                    <div style={{
                        flex: "0 1 auto",
                    }}>
                        <Form
                            form={formSearcherInverter}
                            preserve={false}
                            style={{
                                padding: 10,
                                background: '#fbfbfb',
                                border: '1px solid #d9d9d9',
                                borderRadius: 2
                            }}
                            initialValues={{
                                SN: "",
                                DistributorName: "",
                                UserID: "",
                                Enabled: ["Enabled", "Disabled"]
                            }}
                        >
                            <Row gutter={24}>
                                <Col span={12} key="SerialNumber">
                                    <Form.Item
                                        name="SerialNumber"
                                        label={t("SN")}
                                    >
                                        <Input placeholder={t("Enter Inverter SN")}
                                            onPressEnter={handleSearchInverter} />
                                    </Form.Item>
                                </Col>
                                <Col span={12} key="DistributorName">
                                    <Form.Item
                                        name="DistributorName"
                                        label={t("Distributor")}
                                    >
                                        <Input placeholder={t("Enter Distributor Name")}
                                            onPressEnter={handleSearchInverter} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: 'right' }}>
                                    <Button type="primary" shape="round" onClick={handleSearchInverter}>
                                        {t("Search")}
                                    </Button>
                                    <Button
                                        shape="round"
                                        style={{ margin: '0 8px' }}
                                        onClick={() => {
                                            formSearcherInverter.resetFields();
                                        }}
                                    >
                                        {t("Clear")}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    <div style={{
                        flex: "1 1 1px",
                        position: "relative",
                    }}>
                        <div ref={refTableContainerInverter} style={{ position: "absolute", height: '100%', width: "100%", overflow: "hidden", }}>
                            <Table
                                columns={[{
                                    title: "",
                                    width: 50,
                                    render: (v, r, idx) => {
                                        return (pageNoInverter * pageSizeInverter + idx + 1);
                                    }
                                }, {
                                    title: t("SN"),
                                    dataIndex: 'SerialName',
                                    width: 200,
                                }, {
                                    title: t("Distributor"),
                                    dataIndex: "DistributorName",
                                    width: 200,
                                }]}
                                pagination={{
                                    pageSizeOptions: [25, 50, 100],
                                    current: pageNoInverter + 1,
                                    pageSize: pageSizeInverter,
                                    total: rowTotalInverter,
                                    showSizeChanger: true,
                                    showTotal: (total) => { return t('Total {{total}}', { total }) },
                                    onShowSizeChange: (current, size) => {
                                        setPageSizeInverter(size);
                                    },
                                    onChange: (page, pageSize) => {
                                        setPageNoInverter(page - 1);
                                    }
                                }}
                                tableLayout="fixed"
                                bordered={true}
                                size="middle"
                                loading={loadingInverter}
                                rowKey="ID"
                                dataSource={rowsInverter}
                                scroll={{ y: tableBodyHeightInverter }}
                                rowSelection={{
                                    type: "checkbox",
                                    selectedRowKeys: selectedKeysInverter,
                                    onChange: handleSelectInverter,
                                    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE]
                                }}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <Button key="Cancel" shape="round" onClick={handleCancle}>{t("Cancel")}</Button>
                <span style={{ display: 'inline-block', width: '30px' }}></span>
                <Button key="Submit" shape="round" type="primary" onClick={handleSubmit}>{t("Submit")}</Button>
            </div>
        </Modal>
    )

}

export default AddInverterBurning;